var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mx-auto b-card-pnf py-0",attrs:{"align":"center"}},[_c('div',{attrs:{"id":"row-404"}},[_vm._v("404")]),_c('br'),_c('div',{attrs:{"id":"row-page-not-found"}},[_vm._v("СТРАНИЦА НЕ НАЙДЕНА")])])}
var staticRenderFns = []

export { render, staticRenderFns }